import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import { Router} from '@angular/router';
import * as moment from 'moment';
import {IMyDpOptions, IMyDateModel} from 'mydatepicker';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {PrincipalService} from '../../../shared';
import {PensionCalculatorSetupService} from '../pension-calculator-setup/pension-calculator-setup.service';
import {PensionCalculatorService} from './pension-calculator.service'
import {HomeService} from '../../home/services/home.service'
import {AzidValidators} from '../../../shared/validators/azid-validators';
import {CurrencyFormat} from '../../../shared/pipes/currency-format.pipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

declare var jQuery:any;

@Component({
  selector: 'app-pension-calculator',
  templateUrl: './pension-calculator.component.html',
  styleUrls: ['./pension-calculator.component.css']
})
export class PensionCalculatorComponent implements OnInit {

  @Output() notify = new EventEmitter();
  public progress:boolean = false;
  public error:boolean = false;
  public showForm:boolean = false;
  public showFullForm:boolean = false;
  public testValue = '10';
  public backspace;
  public formtedDob;
  public userAge;
  public currencySymbol = 'IDR';
  public ageFailure:boolean = true;
  public validationOffOnload:boolean = false;
  public ageError:boolean = false;
  public lifeExpectedError:boolean = false;
  public inflationError:boolean = false;
  public savedData;
  public calculatedPension;
  public monthlyContribution:boolean = false;
  public noMonthlyContribution:boolean = false;
  public errorMessage:string = "Server Error";
  public defaultsetupValues:Array<Object>;
  public referenceTextDirty:string;
  public birthDate:Object;
  public userRole = '';
  public disableSince = {year: moment().year(), month: (moment().get('month') + 1), day: moment().date()}
  public myDatePickerOptions:IMyDpOptions = {
    dateFormat: 'dd-mmm-yyyy',
    showTodayBtn: true,
    minYear: 1950,
    markCurrentDay: true,
    showSelectorArrow: true,
    showClearDateBtn: false,
    editableDateField: true,
    disableSince: this.disableSince
  };
  public browserLang:string;
  public lang;
  public numberMask = createNumberMask({
    prefix: '',
    suffix: '%',
    integerLimit: '3',
    allowDecimal: true,
    decimalLimit: 10,
    includeThousandsSeparator: false
    // This will put the dollar sign at the end, with a space.
  });
  public yearMask = createNumberMask({
    prefix: '',
    suffix: ' Tahun',
    integerLimit: '3',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: ''
    // This will put the dollar sign at the end, with a space.
  });
  public currMask = createNumberMask({
    prefix: 'IDR ',
    suffix: '',
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: '48'
    // This will put the dollar sign at the end, with a space.
  });
  public guide = false;
  public showPensionResult:boolean = false;
  public showDetailPensionResult:boolean = false;
  public showDetailLink:boolean = false;
  public showLink:boolean = false;
  public hideLink:boolean = false;
  public displayMessage:string = '';
  public pensionCalcultorForm = new FormGroup({
    'dateOfBirth': new FormControl('', Validators.required),
    'costOfLiving': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupMoneyFieldValidWithFormControl])),
    'monthlyIncome': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupMoneyFieldValidWithFormControl])),
    'inflationRate': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'retirementAge': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'lifeExpected': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'pensionSavingBalance': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupMoneyFieldValidWithFormControl])),
    'otherSavingBalance': new FormControl('', Validators.required),
    'annualDevResults': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'totalCurrentMonthlyContribution': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupMoneyFieldValidWithFormControl])),
    'avgSalaryIncYear': new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl]))
  });

  // public pensionCalcultorForm: FormGroup;
  public dateOfBirth:AbstractControl = this.pensionCalcultorForm.get('dateOfBirth');
  public costOfLiving:AbstractControl = this.pensionCalcultorForm.get('costOfLiving');
  public monthlyIncome:AbstractControl = this.pensionCalcultorForm.get('monthlyIncome');
  public inflationRate:AbstractControl = this.pensionCalcultorForm.get('inflationRate');
  public retirementAge:AbstractControl = this.pensionCalcultorForm.get('retirementAge');
  public lifeExpected:AbstractControl = this.pensionCalcultorForm.get('lifeExpected');
  public pensionSavingBalance:AbstractControl = this.pensionCalcultorForm.get('pensionSavingBalance');
  public otherSavingBalance:AbstractControl = this.pensionCalcultorForm.get('otherSavingBalance');
  public annualDevResults:AbstractControl = this.pensionCalcultorForm.get('annualDevResults');
  public totalCurrentMonthlyContribution:AbstractControl = this.pensionCalcultorForm.get('totalCurrentMonthlyContribution');
  public avgSalaryIncYear:AbstractControl = this.pensionCalcultorForm.get('avgSalaryIncYear');

  constructor(public pensionSetupService:PensionCalculatorSetupService,
              public pensionCalculatorService:PensionCalculatorService,
              public homeService:HomeService,
              private translate:TranslateService,
              public principalService:PrincipalService,
              public router:Router) {

              this.lang = translate.currentLang;

              this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                this.browserLang = event.lang
                this.lang = this.browserLang;
              });
            }

  ngOnInit() {
    this.principalService.identity(true).then((account) => {
      this.userRole = account.authorities[0];
      if (this.userRole == 'ROLE_EMPLOYEE') {
        this.getUserDateOfBirth();
      }
      if(account == null){
        this.router.navigate(['login']);
        this.error = true;
      }
    },(error) => {
      this.router.navigate(['login']);
      this.error = true;
    });
    this.setDefaultValue();
    this.formValueGetChanged();
  }
  ngAfterViewInit() {
  }

  public maskT(val) {
    let numMak = createNumberMask({
      prefix: '',
      suffix: ' ' + val,
      integerLimit: '3',
      thousandsSeparatorSymbol: ''
      // This will put the dollar sign at the end, with a space.
    });
    return numMak;
  }

  public setDefaultValue() {
    this.showForm = false;
    this.progress = true;
    let val = 0;
    this.pensionSetupService.getDefaultSetupValues(val)
      .subscribe(
        (response) => {
          this.progress = false;
          this.showForm = true;
          this.defaultsetupValues = response;
          this.inflationRate.patchValue(this.defaultsetupValues['inflationRate'] + "%");
          this.retirementAge.patchValue(this.defaultsetupValues['retirementAge'] + " Tahun");
          this.lifeExpected.patchValue(this.defaultsetupValues['lifeExpected'] + " Tahun");
          this.annualDevResults.patchValue(this.defaultsetupValues['annualDevResults'] + "%");
          this.avgSalaryIncYear.patchValue(this.defaultsetupValues['avgSalaryIncYear'] + "%");
          this.pensionSavingBalance.patchValue(this.defaultsetupValues['pensionSavingBalance']);
          this.otherSavingBalance.patchValue(0);
          this.totalCurrentMonthlyContribution.patchValue(this.defaultsetupValues['pensionContribution']);

        },
        (error) => {
          this.showForm = false;
          this.error = true;

          // console.log('Some error has occurred while retrieving Data');
        }
      );
  }

  public activateValidation() {
    this.validationOffOnload = true;
  }

  public calculatePension() {
    this.showDetailPensionResult = false;
    let dateOfBirth = this.dateOfBirth.value;
    //this.userAge = this.getAge(dateObject);
    this.formtedDob = this.getFormattedDate(dateOfBirth.date);
    var retirementAge = (this.retirementAge.value).replace(/[^0-9]/g, '');
    let otherSavinBlance;
    if(this.otherSavingBalance.value != 0){
      otherSavinBlance = (this.otherSavingBalance.value).replace(/[^\d\.]/g, '');

    } else {
      otherSavinBlance = 0;
    }
    this.savedData = {
      'dateOfBirth': this.formtedDob,
      'costOfLiving': (this.costOfLiving.value).replace(/[^\d\.]/g, ''),
      'monthlySalary': (this.monthlyIncome.value).replace(/[^\d\.]/g, ''),
      'inflationRate': (this.inflationRate.value).replace('%', ''),
      'retirementAge': retirementAge,
      'lifeExpected': (this.lifeExpected.value).replace(/[^0-9]/g, ''),
      'pensionSavingBalance': (this.pensionSavingBalance.value).replace(/[^\d\.]/g, ''),
      'otherSavingBalance': otherSavinBlance,
      'annualDevResults': (this.annualDevResults.value).replace('%', ''),
      'monthlyContribution': (this.totalCurrentMonthlyContribution.value).replace(/[^\d\.]/g, ''),
      'avgSalaryIncYear': (this.avgSalaryIncYear.value).replace('%', '')
    };


    this.pensionCalculatorService.calculatePension(this.savedData).subscribe(
      data => {
        this.error = false;
        this.showPensionResult = true;
        this.showDetailLink = true;
        this.showDetailPensionResult = true;
        this.calculatedPension = data;
        if (this.calculatedPension.monthlyContribution <= 0.00) {
          this.monthlyContribution = false;
          this.noMonthlyContribution = true;
        } else {
          this.monthlyContribution = true;
          this.noMonthlyContribution = false;
        }
        this.calculatedPension = {
          'costOfLiving': this.numberWithCommas(this.calculatedPension.costOfLiving),
          'fundNeedOnRetirement': this.numberWithCommas(this.calculatedPension.fundNeedOnRetirement),
          'retirementIncomeProjection': this.numberWithCommas(this.calculatedPension.retirementIncomeProjection),
          'retirementIncomeLoss': this.numberWithCommas(this.calculatedPension.retirementIncomeLoss),
          'monthlyContribution': this.numberWithCommas(this.calculatedPension.monthlyContribution),
          "lastSalary": this.numberWithCommas(this.calculatedPension.lastSalary),
          "replacementRatio": this.calculatedPension.replacementRatio,
          "additionalContributionReqPercentage": this.calculatedPension.additionalContributionReqPercentage
        };
        this.triggerScrollToOffsetOnly(2000);
      },
      (error) => {
        this.error = true;
        this.showPensionResult = false;
        this.showDetailPensionResult = false;
      });
  }

  public triggerScrollToOffsetOnly(offset: number = 0) {

    // const config: ScrollToConfigOptions = {
    //   offset
    // };

    // this._scrollToService.scrollTo(config);
  }


  formValueGetChanged() {
    this.pensionCalcultorForm.valueChanges.subscribe(
      data => {
        this.showPensionResult = false;
    });
  }

  public getFormattedDate(date) {
    var year = date.year;
    var month = date.month;
    month = month > 9 ? month : '0' + month;
    var day = date.day;
    if ((date.day) > 9) {
      day = date.day;
    } else {
      day = '0' + day;
    }

    return day + '-' + month + '-' + year;
  }

  public onNotify(message:string):void {
    this.referenceTextDirty = message;
  }

  public getUserDateOfBirth() {
    this.homeService.getProfile().subscribe((response) => {
      var dob = moment(response.dateOfBirth).format('ddd, DD MMM YYYY HH:mm:ss ZZ')
      var date = new Date(dob);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      this.birthDate = {date: {year: year, month: month, day: day}};
    });
  }

  getDateObject(date) {
    let mainDate = date.year + '-' + date.month + '-' + date.day;
    return mainDate;
  }

  public checkFormat() {
    return false;
  }

  public handlePensionAgeError(event) {
    let dateOfBirth = this.dateOfBirth.value;
    let lifeExpected = (this.lifeExpected.value).replace(/[^0-9]/g, '');
    this.userAge = this.getAge(dateOfBirth);
    if ((this.retirementAge.value).replace(/[^0-9]/g, '') != '' && (this.retirementAge.value).replace(/[^0-9]/g, '') <= this.userAge) {
      this.ageError = true;
      this.ageFailure = false;
    }
    if (parseInt(lifeExpected) < parseInt((this.retirementAge.value).replace(/[^0-9]/g, ''))) {
      this.lifeExpectedError = true;
    }
    if (parseInt(lifeExpected) > parseInt((this.retirementAge.value).replace(/[^0-9]/g, ''))) {
      this.lifeExpectedError = false;
    }
    if (parseInt((this.retirementAge.value).replace(/[^0-9]/g, '')) > 100) {
      this.retirementAge.patchValue('');
      this.ageError = false;
    }
    if (parseInt((this.retirementAge.value).replace(/[^0-9]/g, '')) > this.userAge) {
      this.ageError = false;
    }
  }

  public handleLifeExpectedError(event) {
    let retireAge = (this.retirementAge.value).replace(/[^0-9]/g, '');
    let lifeExpected = (this.lifeExpected.value).replace(/[^0-9]/g, '');
    if (parseInt(lifeExpected) < parseInt(retireAge)) {
      this.lifeExpectedError = true;
    }
    if (parseInt(lifeExpected) > 100) {
      this.lifeExpected.patchValue('');
      this.lifeExpectedError = false;
    }
    if (parseInt(lifeExpected) > parseInt(retireAge)) {
      this.lifeExpectedError = false;
    }
  }

  public handleInflationRate(event) {
    let inflation = (this.inflationRate.value).replace('%', '');
    if (inflation > 20) {
      this.inflationError = true;
      this.inflationRate.patchValue('');
      event.preventDefault();
    }
    if (inflation <= 20) {
      this.inflationError = false;
    }
  }

  public handlePercentage(event, val) {
    let formcontrolval;
    if (val == 1) {
      formcontrolval = (this.annualDevResults.value).replace('%', '');
    }
    if (val == 2) {
      formcontrolval = (this.avgSalaryIncYear.value).replace('%', '');
    }
    if (formcontrolval > 100 && val == 1) {
      this.annualDevResults.patchValue('');
    }
    if (formcontrolval > 100 && val == 2) {
      this.avgSalaryIncYear.patchValue('');
    }

  }

  public getAge(dateString) {
    var birthDate = dateString.date;
    var year = birthDate.year;
    var month = birthDate.month;
    var day = birthDate.day;
    month = month > 9 ? month : '0' + month;
    day = day > 9 ? day : '0' + day;
    var age = moment().diff((year + '-' + month + '-' + day), 'years');
    return age;
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

}
